import axiosRequest from '../index'
import api from '../api'

export function geth5Token (clientid) {
  const url = api.mmah5tokenV2
    .replace('{clientid}', clientid)
  return axiosRequest(url, {
    needEncrypt: false,
    needXsign: false
  })
}

export function getDashboardFunctions (uin, type) {
  const url = api.getDashboardFunctions
    .replace('{uin}', uin)
    .replace('{type}', type)
  return axiosRequest(url, {
    needEncrypt: false,
    needXsign: false
  })
}

export function getProfile (uin) {
  const url = api.getProfile
    .replace('{uin}', uin)
  return axiosRequest(url, {
    needEncrypt: false,
    needXsign: false
  })
}
